import { clsx } from 'clsx'

import { Icon, useOlarkStore } from '@fv/client-components'
import { useDebouncedValue } from '@fv/client-core'

import { DraggableButton } from '@/components/DraggableButton/DraggableButton'

import { useAccountFeatures } from '../auth'
import { useChatPanel } from './ChatPanelProvider'

const STORAGE_KEY = 'shipper-floating-chat-link-corner'

export const FloatingChatLink = () => {
  const { chatBot } = useAccountFeatures()
  const { togglePanel, isPanelOpen, openLiveChat } = useChatPanel()
  const isOlarkBoxOpen = useOlarkStore(s => s.isOlarkBoxOpen ?? false)
  const isConversationActive = useOlarkStore(
    s => s.isConversationActive ?? false,
  )
  const debouncedIsOpen = useDebouncedValue(isPanelOpen, 50)
  const isHidden = debouncedIsOpen || isOlarkBoxOpen

  if (!chatBot) return null

  return (
    <DraggableButton
      className={clsx({
        'pointer-events-none': isHidden,
      })}
      buttonClassName={clsx(
        'h-14 w-14 rounded-full border-[.35rem] bg-fv-blue-50 shadow-lg shadow-fv-gray-dark/40 transition-[transform,opacity,border-color] duration-300 hover:scale-110 active:scale-95 justify-center items-center flex outline-4 relative outline-white outline group',
        isHidden ? 'opacity-0' : 'opacity-100',
        isConversationActive ? 'border-fv-blue' : 'border-fv-green',
      )}
      onClick={
        isConversationActive
          ? () => openLiveChat({ shouldClosePanel: false })
          : togglePanel
      }
      storageKey={STORAGE_KEY}
    >
      <Icon
        icon={isConversationActive ? 'user' : 'pallet-jack'}
        className="group-hover:text-fv-gray-dark"
      />
      <div className="text-[.6rem] font-semibold mt-1">CHAT</div>
      {isConversationActive && (
        <div className="absolute right-0 border-[.55rem] border-fv-green left-1/2 h-3 w-3 -top-7 -translate-x-1/2 border-transparent border-b-fv-blue" />
      )}
    </DraggableButton>
  )
}
